import { InitAltParams, InitParams } from '@/app/types'
import { captureException } from '@sentry/nextjs'
import axios from 'axios'
import axiosRetry from 'axios-retry'

axiosRetry(axios, {
	retries: 3,
	retryDelay: (retryCount) => {
		console.log('RETRYING INIT')
		console.warn(`retry attempt: ${retryCount}`)
		return retryCount * 2000
	},
})
export async function init(params: InitParams) {
	try {
		const response = await axios.get(
			process.env.NEXT_PUBLIC_BACKEND_URL + '/hotels/init',
			{ params, withCredentials: true }
		)

		return response.data
	} catch (e) {
		console.error('There has been an error in the init function', e)
		captureException(`INIT ERROR: ${e}, ${params}`)
	}
}

export async function initAlt(params: InitAltParams) {
	try {
		const response = await axios.get(
			process.env.NEXT_PUBLIC_BACKEND_URL + '/hotels/init-2',
			{ params, withCredentials: true }
		)

		return response.data
	} catch (e) {
		console.error('There has been an error in the init-2 function', e)
		captureException(`INIT-2 ERROR: ${e}, ${params}`)
	}
}
